module.exports = __webpack_public_path__ + "static/img/map-0.7b429b56.png";